import { Component, Input, OnChanges, OnInit, Inject, EventEmitter, Output, DOCUMENT } from '@angular/core';

import { ResultItem } from '../../../models/search-response.interface';

@Component({
  selector: 'app-search-card',
  templateUrl: './search-card.component.html',
  standalone: false,
})
export class SearchCardComponent implements OnInit, OnChanges {
  @Input({ required: true }) searchCardResponse: ResultItem;
  @Input() isLoading: boolean;
  @Input() showSkeleton: boolean;
  @Input() toType?: 'full' | 'title';
  @Output() clearSearchInput = new EventEmitter<void>();

  skeletonItems: number[] = Array(1).fill(0);
  title: string | null;
  isInternalDocumentUri: boolean | undefined = undefined;
  constructor(@Inject(DOCUMENT) private document: Document) {}

  ngOnInit() {
    this.updateInternalDocumentUri();
  }

  ngOnChanges() {
    this.title = this.searchCardResponse.documentTitle?.replace(/\s*\|\s*(Worldpay Developer Hub|Worldpay Developers)$/, '') || '';
    this.updateInternalDocumentUri();
  }

  onCardClick() {
    this.clearSearchInput.emit();
  }

  private updateInternalDocumentUri() {
    const uri = this.searchCardResponse?.documentURI;
    if (uri) {
      try {
        this.isInternalDocumentUri = new URL(uri).origin === this.document.location.origin;
      } catch {
        this.isInternalDocumentUri = false;
      }
    } else {
      this.isInternalDocumentUri = false;
    }
  }
}